export const FILTER_TYPE_USERS = "users";
export const FILTER_TYPE_QUEUES = "queues";


export const USER_STATUSSES = ["active", "inactive", "deleted", "all"];

export const filtersSchema = {
    "id": "/filtersSchema",
    "type" : "array",
    "items" : {
        "properties" : {
            "filterName" : {"type": "string"},
            "filterType" : {"enum": [FILTER_TYPE_QUEUES, FILTER_TYPE_USERS]},
            "departments" : {
                "type": "array",
                "items": {"type": "string"}
            },
            "divisions" : {
                "type": "array",
                "items" : {"$ref": "/filterWithIdAndName"}
            },
            "groups" : {
                "type": "array",
                "items" : {"$ref": "/filterWithIdAndName"}
            },
            "languages" : {
                "type": "array",
                "items" : {"$ref": "/filterWithIdAndName"}
            },
            "multipleQueues" : {
                "type" : "array",
                "items" : {"$ref": "/filterWithIdAndName"}
            },
            "queueActivations" : {
                "type": "array",
                "items" : {"$ref": "/filterWithIdAndName"}
            },
            "queues" : {
                "type": "array",
                "items" : {"$ref": "/filterWithIdAndName"}
            },
            "skills" : {
                "type": "array",
                "items" : {"$ref": "/filterWithIdAndName"}
            },
            "skillGroups" : {
                "type": "array",
                "items" : {"$ref": "/filterWithIdAndName"}
            },
            "teams" : {
                "type": "array",
                "items" : {"$ref": "/filterWithIdAndName"}
            },
            "users" : {
                "type": "array",
                "items" : {"$ref": "/filterWithIdAndName"}
            },
            "userStatus" : {"enum": USER_STATUSSES},
        },
        "required" : ["filterName", "filterType"]
    }
};

export const filterWithIdAndNameSchema = {
    "id": "/filterWithIdAndName",
    "type" : "object",
    "properties": {
        "id" : {"type": "string"},
        "name" : {"type": "string"}
    },
    "required" : ["id", "name"]
};